import React, { Component } from "react";
import { UserContext } from "../../Context";

import FavsTable from "../../components/FavsTable/FavsTable";
import Loading from "../../components/loading/Loading";

export default class Favs extends Component {
  render() {
    return (
      <UserContext.Consumer>
        {userContext => {
          const my = userContext.my || {};
          const favs = my.favs || {};
          return (
            <div className="favs">
              {!!userContext.myLoading ? (
                <div className="body padded-body full-body-content center-items">
                  <Loading />
                </div>
              ) : (
                <FavsTable addFlag={userContext.addFlag} favs={favs} />
              )}
            </div>
          );
        }}
      </UserContext.Consumer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/favs/Favs.js